import React from "react";

const Coralogix = () => {
  React.useEffect(() => {
    if (process.env.NODE_ENV === "development") {
      return;
    }

    if (typeof window?.dCoralogix?.init === "function") {
      window.dCoralogix.init({
        application: "msp-ui",
        deploymentId: "0",
        coralogixDomain: "US1",
        user_context: {
          user_name: "GuestUser",
          user_id: "GuestUser",
        },
        maskClass: /oui-icon -arrow/g,
        ignoreUrls: [
          new RegExp("^https://fonts.gstatic.com.*"),
          new RegExp("^https://fonts.googleapis.com.*"),
        ],
      });
    }
  }, []);

  return null;
};

export default Coralogix;
